import React from 'react';
import '../scss/TeamDetailsModal.scss';
import { FaTimes, FaPhone, FaEnvelope, FaMapMarkerAlt, FaUsers, FaTrophy } from 'react-icons/fa';

function TeamDetailsModal({ team, isOpen, onClose }) {
  if (!isOpen || !team) return null;

  return (
    <div className="team-details-modal-overlay" onClick={onClose}>
      <div className="team-details-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="team-logo-section">
            <div className="team-logo">
              <img 
                src={`https://football.pebbledesigns.co.uk/api/images/teams/${team.team_id}/logo-light.png`}
                alt={`${team.team_name} logo`}
                onError={(e) => {
                  e.target.src = `https://football.pebbledesigns.co.uk/api/images/teams/${team.team_id}/logo-dark.png`;
                  e.target.onerror = () => {
                    e.target.src = `https://football.pebbledesigns.co.uk/api/images/teams/logo-light.png`;
                    e.target.onerror = () => {
                      e.target.style.display = 'none';
                    };
                  };
                }}
              />
            </div>
            <div className="team-title">
              <h2>{team.team_name}</h2>
              {team.manager_name && (
                <p className="manager-name">Managed by {team.manager_name.split(' ').map(name => name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()).join(' ')}</p>
              )}
            </div>
          </div>
          <button className="close-button" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="modal-content">
          <div className="team-info-grid">
            <div className="info-section">
              <h3><FaMapMarkerAlt /> Location</h3>
              <div className="info-content">
                {team.location && <p><strong>Location:</strong> {team.location}</p>}
                {team.county && <p><strong>County:</strong> {team.county}</p>}
              </div>
            </div>

            <div className="info-section">
              <h3><FaUsers /> Team Details</h3>
              <div className="info-content">
                {team.age_group && <p><strong>Age Group:</strong> {team.age_group}</p>}
                {team.team_type && <p><strong>Type:</strong> {team.team_type}</p>}
                {team.league_name && <p><strong>League:</strong> {team.league_name}</p>}
              </div>
            </div>

            {team.manager_name && (
              <div className="info-section">
                <h3><FaTrophy /> Manager Information</h3>
                <div className="info-content">
                  <p><strong>Manager:</strong> {team.manager_name.split(' ').map(name => name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()).join(' ')}</p>
                  {team.manager_phone && (
                    <p>
                      <FaPhone /> <strong>Phone:</strong> 
                      <a href={`tel:0${team.manager_phone}`}> 0{team.manager_phone}</a>
                    </p>
                  )}
                  {team.manager_email && (
                    <p>
                      <FaEnvelope /> <strong>Email:</strong> 
                      <a href={`mailto:${team.manager_email}`}> {team.manager_email}</a>
                    </p>
                  )}
                </div>
              </div>
            )}
          </div>

          <div className="modal-actions">
            <button className="close-btn" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TeamDetailsModal; 